import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "../models/user";
import { environment } from "src/environments/environment";
import { ApiResponse, Auth, OtpChallenge } from "../models/auth";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: "root",
})
// /auth/signin
export class AuthService {
  constructor(private http: HttpClient) { }

  getBaseUrl(): string {
    return environment.baseUrl;
  }

  // http://3.13.214.62:1905/urassauth/soa/auth
  ///p2p/auth/signin

  // login(user: any): Observable<Auth> {
  //   return this.http.post<Auth>(
  //     `${environment.baseUrl}/api/v1/AppUser/signin`,
  //     user,
  //     httpOptions
  //   );
  // }

  getBranchProfile(id: number): Observable<any> {
  const url = `${environment.baseUrl}/api/v1/bank-branches/${id}`;
  return this.http.get<any>(url);
}

  login(user: any): Observable<Auth> {
    return this.http.post<Auth>(
      `${environment.baseUrl}/church/auth/login`,
      user,
      httpOptions
    );
  }
  verifyOPT(otpData: any): Observable<any> {
    const verifyUrl = `${environment.baseUrl}/church/auth/verify-otp`;
    return this.http.post<any>(verifyUrl, otpData)
  }

  resendOtp(username: string): Observable<ApiResponse<OtpChallenge>> {
    return this.http.post<ApiResponse<OtpChallenge>>(
      `${environment.baseUrl}/church/auth/resend-otp`,
      { username },
      httpOptions
    );
  }

  register(user: any): Observable<{ message: string }> {
    const registerUrl = `${environment.baseUrl}/p2p/auth/signup`;

    return this.http.post<{ message: string }>(registerUrl, user)
  }

  onboardUser(user): Observable<{ message: string }> {
    const onboardUserUrl = `${environment.baseUrl}/p2p/otherusers/signup`;

    return this.http.post<{ message: string }>(onboardUserUrl, user)
  }

  resetPassword(params: any): Observable<{ message: string }> {
    const resetPasswordUrl = `${environment.baseUrl}/api/v1/AppUser/password/verify-otp-and-reset`;

    return this.http.post<{ message: string }>(
      resetPasswordUrl,
      params
    );
  }

  forgotPassword(params: any): Observable<{ message: string }> {
    const resetPasswordUrl = `${environment.baseUrl}/api/v1/AppUser/password/request-otp`;

    return this.http.post<{ message: string }>(resetPasswordUrl, params);
  }

  getChurchProfilebyId(id: any): Observable<any> {
    const churchUnitProfileUrl = `${environment.baseUrl}/api/church-unit-profile/get/${id}/profile`;

    return this.http.get<any[]>(churchUnitProfileUrl);
  }

  getChurchUnit(id: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/church-units/${id}`);
  }

  exchangeAzureToken(tempToken: string): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl}/api/v1/auth/azure/session-data`,
      { token: tempToken },
      httpOptions
    );
  }

  verifyConsentToken(token: string): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl}/api/v1/auth/member/consent/verify?token=${token}`
    );
  }

  confirmConsent(token: string): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl}/api/v1/auth/member/consent/confirm`,
      { token },
      httpOptions
    );
  }

  declineConsent(token: string): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl}/api/v1/auth/member/consent/decline`,
      { token },
      httpOptions
    );
  }

  validateSession(): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl}/church/auth/validate-session`
    );
  }
}
